import Page from "./../src/client/pages/stories";
export default Page;
